import { View } from '@aws-amplify/ui-react';
import { useNavigate } from 'react-router-dom';
import '../project/HomePageProject.css';
import { useTheme } from '@aws-amplify/ui-react';
import { listUsers } from '../graphql/queries';
import { generateClient } from 'aws-amplify/api';
import { useEffect, useState } from 'react';
import CreateAndSeacrh from '../commons/CreateAndSeacrh';
import TableComponent from '../commons/TableComponent';
import ModalView from '../commons/ModalView';
import ViewPageUser from './ViewPageUser';

const client = generateClient();
const LIMIT_PROYECTS_BY_PAGE = 4;

function HomePageuser() {
    const [users, setUsers] = useState([]);
    const [nextToken, setNextToken] = useState(null);
    const [prevTokens, setPrevTokens] = useState([]); // Store previous tokens
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [error, setError] = useState('');
    const [popup, setPopup] = useState(false);
    const [selectUser, setSelectUser] = useState({})
    const navigate = useNavigate();

    const { tokens } = useTheme();

    const handleuserPageToForm = () => {
        navigate("/admin/user/form");
    };

    const fetchUsers = async (token = null) => {
        try {
            const response = await client.graphql({
                query: listUsers,
                variables: {
                    limit: LIMIT_PROYECTS_BY_PAGE,
                    nextToken: token
                }
            });
            return response.data.listUsers;
        } catch (e) {
            console.log('Something went wrong', e);
            return null;
        }
    };

    const fetchAllUsers = async () => {
        try {
            const response = await client.graphql({ query: listUsers });
            return response.data.listUsers.items;
        } catch (e) {
            console.log('Something went wrong', e);
            return [];
        }
    };

    useEffect(() => {
        const initializeUsers = async () => {
            const allUsers = await fetchAllUsers();
            setUsers(allUsers);
            const totalPagesCalculated = Math.ceil(allUsers.length / LIMIT_PROYECTS_BY_PAGE);
            setTotalPages(totalPagesCalculated);

            // Fetch the first page of Users
            const result = await fetchUsers();
            if (result && result.items) {
                setFilteredUsers(result.items);
                setNextToken(result.nextToken);
            }
        };

        initializeUsers();
    }, []);

    useEffect(() => {
        const fetchUsersForPage = async () => {
            const result = await fetchUsers(nextToken);
            if (result && result.items) {
                setFilteredUsers(result.items);
                setNextToken(result.nextToken);
            }
        };

        fetchUsersForPage();
    }, [currentPage]);

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setPrevTokens([...prevTokens, nextToken]);
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            const newPrevTokens = prevTokens.slice(0, -1);
            setNextToken(newPrevTokens[newPrevTokens.length - 1] || null);
            setPrevTokens(newPrevTokens);
            setCurrentPage(currentPage - 1);
        }
    };

    const handleSearch = (event) => {
        const searchTerm = event.target.value.toLowerCase();
        setSearchTerm(searchTerm);

        if (searchTerm === '') {
            handleClearSearch();
            return;
        }

        const filtered = users.filter(user => user.username.toLowerCase().includes(searchTerm));
        if (filtered.length > 0) {
            setFilteredUsers(filtered);
            setError('');
        } else {
            setFilteredUsers([]);
            setError('No se encontró ningún proyecto con ese nombre.');
        }
    };

    // const handleSearchSubmit = (event) => {
    //     const filtered = users.filter(user => user.username.toLowerCase().includes(searchTerm));
    //     if (filtered.length > 0) {
    //         setFilteredUsers(filtered);
    //         setError('');
    //     } else {
    //         setFilteredUsers([]);
    //         setError('No se encontró ningún proyecto con ese nombre.');
    //     }
    // };

    const handleClearSearch = async () => {
        setSearchTerm('');
        const result = await fetchUsers(prevTokens[currentPage - 1]);
        if (result && result.items) {
            setFilteredUsers(result.items);
            setNextToken(result.nextToken);
        }
        setError('');
    };

    const handlerClickOnObject = async (userId) => {
        setPopup(true);
        const selectUserData = users.filter((user) => user.id === userId)[0]
        setSelectUser(selectUserData);
    };

    const closePopup = async () => {
        reloadUsers();
        setPopup(false);
    };

    const reloadUsers = async () => {
        const allUsers = await fetchAllUsers();
        setUsers(allUsers);
        const totalPagesCalculated = Math.ceil(allUsers.length / LIMIT_PROYECTS_BY_PAGE);
        setTotalPages(totalPagesCalculated);

        // Fetch the first page of Users
        const tokenForCurrentPage = prevTokens[currentPage - 2] || null;
        const result = await fetchUsers(tokenForCurrentPage);
        if (result && result.items) {
            setFilteredUsers(result.items);
            setNextToken(result.nextToken);
        }
    };

    return (
        <div className="container">
            <CreateAndSeacrh
                tokens={tokens}
                handleObjectPageToForm={handleuserPageToForm}
                searchTerm={searchTerm}
                handleSearch={handleSearch}
                handleClearSearch={handleClearSearch}
                valuePage={"Crear un usuario"}
            />
            <TableComponent
                error={error}
                value={'Username'}
                objects={filteredUsers}
                handlerClickOnObject={handlerClickOnObject}
                currentPage={currentPage}
                totalPages={totalPages}
                handleNextPage={handleNextPage}
                handlePreviousPage={handlePreviousPage}
                nameObject={'username'}
            />

            <ModalView isOpen={popup} onClose={closePopup} type='modal-content-view'>
                <View style={formStyle} font="font.inverse">
                    <ViewPageUser
                        selectUser={selectUser}
                        onCancel={closePopup}
                    />
                </View>
            </ModalView>
        </div>
    );
}

const formStyle = {
    // padding: '50px 20px',
    backgroundColor: '#282c34',
    padding: '1rem',
    width: '30rem',
    height: '28rem',
    color: 'white'
};

export default HomePageuser;
